module.exports = __webpack_public_path__ + "img/svg/explain-2.93e6f539b7cb29b1cce97b15fae4ada7.svg";